<div class="secondary-info-comp">
  <div class="filter-container">
    <app-filter-button label="Åtgärdstyp" [allValues]="allMachinePerformanceTypes"
      [(selectedValues)]="filterValues.type" (selectedValuesChange)="onFiltersChanged()"></app-filter-button>
    <app-filter-button label="Produktionsteknikerområde" [allValues]="allProductionTechnicianAreas"
      [(selectedValues)]="filterValues.area" (selectedValuesChange)="onFiltersChanged()"></app-filter-button>
    @if (machineType === MachineType.Forwarder) {
    <app-filter-button label="Storlek" [allValues]="allMachineSizes" [(selectedValues)]="filterValues.size"
      (selectedValuesChange)="onFiltersChanged()"></app-filter-button>
    }
    <app-filter-input-chips [(selectedValues)]="filterValues" (selectedValuesChange)="onFiltersChanged()"
      [tableId]="tableId"></app-filter-input-chips>
  </div>

  <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="selectedTabChange($event)"
    class="performance-tab-group" mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="Skotare"></mat-tab>
    <mat-tab label="Skördare"></mat-tab>
  </mat-tab-group>

  <section class="table-container mat-elevation-z8">
    <table mat-table [dataSource]="machinePerformancesDataSource" class="mat-elevation-z2 table" matSort>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Åtgärdstyp </th>
        <td mat-cell *matCellDef="let element">
          @if(isLoading) {
          <div class="skeleton-line"></div>
          } @else {
          {{ getMachinePerformanceTypeLabel(element.type) }}
          }
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <mat-form-field appearance="outline">
            <mat-label>Åtgärdstyp</mat-label>
            <mat-select [(ngModel)]="newItem.type" name="type">
              @for (machinePerformanceType of machinePerformanceTypes; track machinePerformanceType) {
              <mat-option [value]="machinePerformanceType">
                {{ machinePerformanceTypeLabels[machinePerformanceType] }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="area">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Produktionsteknikerområde </th>
        <td mat-cell *matCellDef="let element"> @if(isLoading) {
          <div class="skeleton-line"></div>
          } @else {
          {{ getAreaLabel(element.area) }}
          }
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <mat-form-field appearance="outline">
            <mat-label>Produktionsteknikerområde</mat-label>
            <mat-select [(ngModel)]="newItem.area" name="area">
              @for (area of areas; track area) {
              <mat-option [value]="area">
                {{ productionTechnicianAreaLabels[area] }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="size">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Storlek </th>
        <td mat-cell *matCellDef="let element">

          @if(isLoading) {
          <div class="skeleton-line"></div>
          }
          @else {
          {{ getMachineSizeLabel(element.size) }}
          }
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <mat-form-field appearance="outline" class="short-text-form-field">
            <mat-label>Storlek</mat-label>
            <mat-select [(ngModel)]="newItem.size" name="size">
              @for (size of sizes; track size) {
              <mat-option [value]="size">
                {{ machineSizeLabels[size] }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="meanStemVolumeInM3FubPerTree">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-align-right"> Medelstam </th>
        <td mat-cell *matCellDef="let element; let i = index" class="text-align-right">
          <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="numeric-form-field">
            <input matInput [value]="element.meanStemVolumeInM3FubPerTree" type="number"
              [(ngModel)]="element.meanStemVolumeInM3FubPerTree" (ngModelChange)="onRowChanged(i)">
          </mat-form-field>
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-align-right">
          <mat-form-field appearance="outline" class="numeric-form-field">
            <input matInput [(ngModel)]="newItem.meanStemVolumeInM3FubPerTree" placeholder="Medelstam">
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="transportDistanceForwarding">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-align-right"> Trp.avs.(m) </th>
        <td mat-cell *matCellDef="let element; let i = index" class="text-align-right">
          <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="numeric-form-field">
            <input matInput [value]="element.transportDistanceForwarding" type="number"
              [(ngModel)]="element.transportDistanceForwarding" (ngModelChange)="onRowChanged(i)">
          </mat-form-field>
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-align-right">
          <mat-form-field appearance="outline" class="numeric-form-field">
            <input matInput [(ngModel)]="newItem.transportDistanceForwarding" placeholder="Transportavstånd">
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="g5InM3FubPerHour">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-align-right"> G5(m3fub/tim) </th>
        <td mat-cell *matCellDef="let element; let i = index" class="text-align-right">
          <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="numeric-form-field">
            <input matInput [value]="element.g5InM3FubPerHour" type="number" [(ngModel)]="element.g5InM3FubPerHour"
              (ngModelChange)="onRowChanged(i)">
          </mat-form-field>
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-align-right">
          <mat-form-field appearance="outline" class="numeric-form-field">
            <input matInput [(ngModel)]="newItem.g5InM3FubPerHour" placeholder="G5">
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element; let i = index;">
          <div class="button-container">
            <button mat-raised-button (click)="saveRow(element, i)" [disabled]="!isRowModified(i)">Spara</button>
            <button mat-raised-button (click)="deleteRow(element)">
              Ta bort
            </button>
          </div>

        </td>
        <td mat-footer-cell *matFooterCellDef>
          <div class="button-container">
            <button mat-raised-button color="primary" (click)="addItem()" [disabled]="!isValidNewItem() || isAddingRow">
              <span>Lägg till</span>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.newly-added-row]="isRowHighlighted(row)"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns" class="table-footer-row"></tr>

    </table>
  </section>
  <mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>
</div>